/**
 * 设备产品配色全局状态管理
 *
 * 用于管理产品外观配色选择，支持：
 * - 全局状态同步：所有使用该 hook 的组件都能获取和更新统一的配色状态
 * - 本地持久化：配色选择会自动保存到 localStorage
 * - 多设备支持：每个设备型号独立配置和存储配色
 * - 跨应用同步：主应用和子应用之间的配色变化会自动同步
 */

import { create } from "zustand";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DeviceType, SUPPORTED_DEVICES } from "@eweadn-qiankun/shared-utils";

// 导入产品图片
import {
  mouseBlack as mouseZ7Black,
  mouseRed as mouseZ7Red,
  mouseSilvery as mouseZ7Silvery,
  mousePurple as mouseZ7Purple,
  mouseZ7MasterPinegreen,
  mouseZ7MasterBlack,
  mouseZ7MasterSilver,
  mouseZ7MasterRed,
  mouseS9UltraV2White,
  mouseS9UltraV2Red,
  mouseS9UltraV2LightPurple,
  mouseS9UltraV2Silver,
  mouseS9UltraWhite,
  mouseS9UltraRed,
  mouseS9UltraBlack,
  mouseS9UltraBlackpurple,
  mouseS9UltraSilver,
  mouseS9ProV2Black,
  mouseS9ProV2White,
  mouseS9ProV2Luotianyi,
  mouseS9UltraV2Luotianyi,
  mouseS9ProBlack,
  mouseS9ProWhite,
  mouseS9ProRed,
  mouseS9ProSilver,
  mouseS9ProBlackpurple,
  mouseS9MaxCyan,
  mouseS9V2MasterMambagreen,
  mouseS9V2MasterPlusBlack,
  mouseS9V2MasterPlusPurple,
  mouseS9V2MasterPlusSilver,
  mouseS9V2MasterPlusRed,
  mouseS9V2UltimateLightblue,
  mouseS9V2UltimateRed,
  mouseS9V2UltimateSilver,
  mouseX23ZhuoyueWhite,
  mouseX23ZhuoyueBerryRed,
  mouseX23ZhuoyueLightBlue,
  mouseA8Panda,
  mouseA8BerryRed,
  mouseS9White,
  mouseS9Black,
  mouseS9SEWhite,
  mouseS9SEBlack,
  mouseX23ProWhite,
  mouseX23ProBlack,
  mouseX23ProBlue,
  mouseX23ProJiangGuoHong,
  mouseX23ProShuMeiPink,
  mousex23ProCyberPanda,
  mouseX23BerryRed,
  mouseX23MaxWhite,
  mouseX23MaxBerryRed,
  mouseX23SELightGreen,
  mouseX23SEWhite,
  mouseX23SEPink,
  mouseX23SEBlack,
  mouseX23SEBerryRed,
  mouseS7ProWhite,
  mouseS7PlusWhite,
  mouseS7PlusBlack,
  mouseS2White,
  mouseS2Black,
  mouseS2Blue,
  mouseS2BerryRed,
  mouseS2Green,
  mouseS7White,
  mouseS7BerryRed,
  mouseS7Green,
  mouseS7seWhite,
  mouseS7seBerryRed,
  mouseS7seGreen,
  mouseS7MaxWhite,
  mouseS7MaxBlackGold,
  mouseS7MaxJiangGuoHong,
  mouseS7UltraWhite,
  mouseS7UltraBlackGold,
  mouseS7UltraJiangGuoHong,
  mouseA6XiangYaWhite,
  mouseA6ProXiangYaWhite,
  mouseA6ProBingChuanBlue,
  mouseA6ProJingdianBlack,
  mouseA6ProYingHuaPink,
  mouseA6MaxXiangYaWhite,
  mouseG2SEAWhite,
  mouseG2SEABlack,
  mouseA7SEWhite,
  mouseA7White,
  mouseA7Black,
  mouseA7ProWhite,
  mouseA7ProBlack,
  mouseAlpha7White,
  mouseAlpha7Black,
  mouseAlpha7Pink,
  mouseAlpha6Blackwhite,
  mouseAlpha6Blackorange,
  mouseAlpha6Berryred,
  mouseZ7MaxBlack,
  mouseX23CarbonBlack,
  mouseX23CarbonQianlan,
  mouseX23CarbonSilver,
  mouseX23LCarbonBlack,
  mouseX23LCarbonSilver,
  mouseGS02ProJiYeBlack,
  mouseGS02ProYueGuangBai,
  mouseE7V2Black,
  mouseE7V2White,
  mouseE7Black,
  mouseE7White,
  mouseE7BerryRed,
  mouseE7LemonGreen,
  mouseE7SkyBlue,
  mouseE7FireRed,
  mouseE7Foggywhite,
  mouseE7ProBlack,
  mouseE7ProWhite,
  mouseE7ProBerryRed,
  mouseE7V2MaxBlack,
  mouseE7V2MaxWhite,
  mouseE7V2MaxBerryRed,
  mouseE9Black,
  mouseE9White,
  mouseE9BerryRed,
  mouseE9LemonGreen,
  mouseE9CarbonBlack,
  mouseE9CarbonWhite,
  mouseE9CarbonBerryRed,
  mouseE11White,
  mouseE11BerryRed,
  mouseE11SakuraPink,
  mouseG5JinShuBlack,
  mouseG5KaiJiaRed,
  mouseG5XiangBinBlue,
  mouseE11V2White,
  mouseE11V2BerryRed,
  keyboardX87heBlackpink,
  keyboardX87heBlue,
  keyboardX87heDuantan,
  keyboardX87heWhite,
  keyboardX87Baifenjianbian,
  keyboardX87Duantan,
  keyboardX87Fushihui,
  keyboardX87Jingmihaiyang,
  keyboardX87Piwen,
  keyboardX87Qingti,
  keyboardX87Tianxinfen,
  keyboardX87Weichen,
  keyboardX87Wutou,
  keyboardX87Xueshanjianbian,
  keyboardX87Piwenbai,
  keyboardX87Zheying,
  keyboardX87Blackpink,
  keyboardx87FlameRed,
  keyboardX87White,
  keyboardX98Purple,
  keyboardX98Taofen,
  keyboardX98Yunjianlan,
  keyboardX98Zheyingzhiguang,
  keyboardSmart875Black,
  keyboardSmart875Red,
  keyboardSmart875Silvery,
  keyboardDeep68White,
  keyboardDeep68Pink,
  keyboardBattle68Black,
  keyboardBattle68Blackred,
  keyboardBattle68Blackyellow,
  keyboardBattle68Weichen,
  keyboardTank68Black,
  keyboardTank68Blackredcontourline,
  keyboardTank68Blackcontourline,
  keyboardTank68Whitecontourline,
  keyboardDeep80MaxWhite,
  keyboardDeep80MaxBerryRed,
  keyboardDeep80MaxBerryRedTranslucent,
  keyboardDeep80ProWhite,
  keyboardDeep80ProBerryRed,
  keyboardDeep80ProBerryRedTranslucent,
  keyboardDk68Black,
  keyboardDk68White,
  keyboardDk68Berryred,
  keyboardDk68StarBlack,
  keyboardDk68StarWhite,
  keyboardDk68StarBerryred,
  keyboardDk68StarZheying,
  keyboardDk68V2Foggyblack,
  keyboardDk68V2Foggywhite,
  keyboardDk68V2Foggypink,
  keyboardDk68V2White,
  keyboardDk68ProBlack,
  keyboardDk68ProWhite,
  keyboardDk68ProBerryred,
  keyboardEweadnDk68ProBlack,
  keyboardEweadnDk68ProWhite,
  keyboardEweadnDk68ProBerryred,
  keyboardDk80White,
  keyboardDk80Whitepink,
  keyboardDk80Zheying,
  keyboardDk80Denggaoxianwhite,
  keyboardDk80Russiawhite,
  keyboardDk80Weichen,
  keyboardDk80Russiaweichen,
  keyboardDk63Black,
  keyboardDk63White,
  keyboardDk63Berryred,
  keyboardDk63V2WhiteSidePrinted,
  keyboardDk63V2WhiteMistSheer,
  keyboardDk63V2WhiteCarbonPattern,
  keyboardDk63V2ContourLine,
  keyboardDk63V2PinkSidePrinted,
  keyboardDk63V2BlackSidePrinted,
  keyboardDk63V2BlackFrontPrinted,
  keyboardDk63V2BlackCarbonPattern,
  keyboardDk63V2FoldingShadow,
  keyboardEs98Blackpurple,
  keyboardEs98Tengwangge,
  keyboardEs98Whiteblue,
  keyboardEs98Whitepink,
  keyboardX75ProWhite,
  keyboardX75ProBlackpink,
  keyboardX75ProGrapePurple,
  keyboardX75ProJiangGuoHong,
  keyboardX75ProMoYingJianBianDengGaoXian3,
  keyboardX75ProPinkGradient,
  keyboardX75ProWhiteDengGaoXian3,
  keyboardX75ProRussiablack,
  keyboardEs68Black,
  keyboardEs68White,
  keyboardEs68Pink,
  keyboardEs68Luotianyi,
  keyboardM98FenDiYe,
  keyboardM98LeiTaoCiJianMao,
  keyboardX75V2ProWhite,
  keyboardX75V2ProBlackpink,
  keyboardX75V2ProGrapePurple,
  keyboardX75V2ProJiangGuoHong,
  keyboardX75V2ProMoYingJianBianDengGaoXian3,
  keyboardX75V2ProPinkGradient,
  keyboardX75V2ProWhiteDengGaoXian3,
  keyboardX75V2Whiteblue,
  keyboardX75V2Blackyellow,
  keyboardX75V2Zheying,
  keyboardX75V2Russianwhiteblue,
  keyboardX75V2Russianweichen,
  keyboardX75GcSilverscreen,
  keyboardX75V3Black,
  keyboardX75V3Silver,
  keyboardX75UltraBlack,
  keyboardX75UltraSilver,
  keyboardExxGamma75Pink,
  keyboardExxGamma75Silver,
  keyboardExxGamma75Black1,
  keyboardExxGamma75Silver1,
  keyboardExxGamma75FeatherRed,
  keyboardExxGamma75FeatherGreen,
  keyboardExxGamma75FeatherPurple,
  keyboardExxGamma75FeatherBlack,
  keyboardExxGamma75proBlack,
  keyboardExxGamma75proGreen,
  keyboardExxGamma75proPurple,
  keyboardExxGamma75proRed,
  keyboardExxGamma75proSilverTwoTone,
  keyboardExxGamma75proSilvery,
  keyboardExxGamma75proEvoKnifeBlackFog,
  keyboardExxGamma75proEvoKnifeBlackThreePiece,
  keyboardExxGamma75proEvoKnifeGreen,
  keyboardExxGamma75proEvoKnifeSilverSidePrinted,
  keyboardExxGamma75proEvoKnifeSilverTwoTone,
  keyboardExxGamma75ultraSilvery,
  keyboardx87v2Blackberry,
  keyboardx87v2Cherryblossompink,
  keyboardx87v2Contourline,
  keyboardx87v2Dust,
  keyboardx87v2Shadowfold,
  keyboardX87sBlackpink,
  keyboardX87sLuotianyi,
  keyboardX87sSakurapink,
  keyboardX87sWeichen,
  keyboardX87sWhitedenggaoxian,
  keyboardX87sZheying,
  keyboardV80Default,
  keyboardV102Default,
  keyboardES68EVOPink,
  keyboardES68EVOBlack,
  keyboardES68EVOSilver,
  keyboardES68LiteBlack,
  keyboardES68LiteSilver,
  keyboardAlpha87Silver,
  keyboardM80Blue,
  keyboardM80White,
  keyboardM71LipstickDot,
  keyboardM71CuteBearLiquidFoundation,
  keyboardM71LipstickCuteLittleBear,
  keyboardM71LiquidFoundationDots,
  keyboardT87JiGuangWhite,
  keyboardT87MoYunHui,
  keyboardT87NingYePink,
  keyboardT87TaoYueWhite,
  keyboardT87YunTianBlue,
  keyboardM98TFTJingTou,
  keyboardM75Pink,
  keyboardM75Green,
  keyboardM75Purple,
  keyboardM75Cat,
  earphoneHg50Default,
  earphoneVx07LuotianyiBlue,
  earphoneVx01Black,
  earphoneVx01White,
  earphoneVx01BerryRed,
  earphoneVx01sBlack,
  earphoneVx01sWhitePink,
  earphoneVx01sBlackOrange,
  earphoneVx02BlackRed,
  earphoneVx02WhiteBlue,
  earphoneVx20Default,
  earphoneVx20Pink,
  earphoneVx20Blue,
  keyboardDk75ProMistyWhite,
  keyboardDk75ProMistyPurple,
  keyboardDk75ProLakeGreen,
  keyboardDk75EWhite,
  keyboardDk75MistyWhite,
  keyboardDk75MistyPurple,
  keyboardDk75MistyPink,
  keyboardDk87BaiFenJianBian,
  keyboardDk87Black,
  keyboardDk87BlackPink,
  keyboardDk87QingTi,
  keyboardDk87Weichen,
  keyboardDk87White,
  keyboardDk108White,
  keyboardDk108Black,
  keyboardDk108BingDaoBlue,
  keyboardDk108BlackPink,
  keyboardDk108QingTiGreen,
  keyboardDk108TaoYaoPink,
  keyboardDk108TianKongBlue,
  keyboardDk108TianShuiBi,
  keyboardDk108WeiChen,
  keyboardDk108XiangYuPurple,
  keyboardDk108YingHuaPink,
  keyboardZAP68Black,
  keyboardZAP68BlackPink,
  keyboardZAP68FoggyBlack,
  keyboardX87NeonMistyBlue,
} from "@eweadn-qiankun/shared-assets";
import instructionUrls from "./config/instructionUrls.json";
import { translatePrefixedColorKey } from "./config/translatePrefixedColorKey";

import {
  PRODUCT_PIC_PLACEHOLDER,
  findRemoteProductPicByModelKey,
  findRemoteProductPicByModelKeyPrefix,
  subscribeRemoteProductPics,
  getRemoteProductPicVersion,
  type RemoteProductPicColor,
} from "./remoteProductPics";

// 配色选项定义
export interface ColorOption {
  key: string; // 配色键值，如 'black', 'red'
  label: string; // 配色i18n键名（不带前缀），如 'black', 'x87heBlack'
  image: string; // 配色对应的图片 URL
  /** 远程色点（纯色/渐变）；本地 DEVICE_CONFIGS 可无 */
  swatchType?: "solid" | "gradient" | string;
  swatchValue?: string;
}

// 设备配色配置
export interface DeviceColorConfig {
  deviceType: DeviceType; // 设备类型
  colors: ColorOption[]; // 支持的配色列表
  defaultColor: string; // 默认配色键值
  /** TFT屏幕宽高 */
  screenWidth?: number;
  screenHeight?: number;
}

export const DEVICE_CONFIGS: Record<string, DeviceColorConfig> = {
  // ==================== 鼠标设备 ====================
  Z7: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "z7Black", image: mouseZ7Black },
      { key: "red", label: "z7Red", image: mouseZ7Red },
      { key: "silvery", label: "z7Silvery", image: mouseZ7Silvery },
      { key: "purple", label: "z7Purple", image: mouseZ7Purple },
    ],
    defaultColor: "black",
  },
  "Z7 Master": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "silver", label: "z7MasterSilver", image: mouseZ7MasterSilver },
      { key: "black", label: "z7MasterBlack", image: mouseZ7MasterBlack },
      { key: "red", label: "z7MasterRed", image: mouseZ7MasterRed },
      {
        key: "pinegreen",
        label: "z7MasterPinegreen",
        image: mouseZ7MasterPinegreen,
      },
    ],
    defaultColor: "silver",
  },
  "S9 Ultra v2": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9ultrav2White", image: mouseS9UltraV2White },
      { key: "red", label: "s9ultrav2Red", image: mouseS9UltraV2Red },
      {
        key: "lightpurple",
        label: "s9ultrav2Lightpurple",
        image: mouseS9UltraV2LightPurple,
      },
      { key: "silver", label: "s9ultrav2Silver", image: mouseS9UltraV2Silver },
      {
        key: "luotianyi",
        label: "s9ultrav2Luotianyi",
        image: mouseS9UltraV2Luotianyi,
      },
    ],
    defaultColor: "white",
  },
  "S9 Pro v2": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "s9prov2Black", image: mouseS9ProV2Black },
      { key: "white", label: "s9prov2White", image: mouseS9ProV2White },
      {
        key: "luotianyi",
        label: "s9prov2Luotianyi",
        image: mouseS9ProV2Luotianyi,
      },
    ],
    defaultColor: "black",
  },

  "S9 SE": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9seWhite", image: mouseS9SEWhite },
      { key: "black", label: "s9seBlack", image: mouseS9SEBlack },
    ],
    defaultColor: "white",
  },

  S9Max: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9ultraWhite", image: mouseS9UltraWhite },
      { key: "black", label: "s9ultraBlack", image: mouseS9UltraBlack },
      { key: "red", label: "s9ultraRed", image: mouseS9UltraRed },
    ],
    defaultColor: "white",
  },
  "S9V2 Master": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9ultrav2White", image: mouseS9UltraV2White },
      {
        key: "mambagreen",
        label: "s9v2MasterMambagreen",
        image: mouseS9V2MasterMambagreen,
      },
      { key: "red", label: "s9ultrav2Red", image: mouseS9UltraV2Red },
      { key: "silver", label: "s9ultrav2Silver", image: mouseS9UltraV2Silver },
    ],
    defaultColor: "white",
  },
  "A8 WB Ultra:moudleId:19": {
    deviceType: DeviceType.Mouse,
    colors: [{ key: "panda", label: "a8WBUltraPanda", image: mouseA8Panda }],
    defaultColor: "panda",
  },
  "A8 WB Ultra:moudleId:20": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "berryred", label: "a8WBUltraBerryRed", image: mouseA8BerryRed },
    ],
    defaultColor: "berryred",
  },
  "S9V2 Master+": {
    deviceType: DeviceType.Mouse,
    colors: [
      {
        key: "black",
        label: "s9v2MasterPlusBlack",
        image: mouseS9V2MasterPlusBlack,
      },
      {
        key: "purple",
        label: "s9v2MasterPlusPurple",
        image: mouseS9V2MasterPlusPurple,
      },
      {
        key: "silver",
        label: "s9v2MasterPlusSilver",
        image: mouseS9V2MasterPlusSilver,
      },
      { key: "red", label: "s9v2MasterPlusRed", image: mouseS9V2MasterPlusRed },
    ],
    defaultColor: "black",
  },
  "S9V2 Ultimate": {
    deviceType: DeviceType.Mouse,
    colors: [
      {
        key: "bingchuangblue",
        label: "s9v2UltimateLightblue",
        image: mouseS9V2UltimateLightblue,
      },
      {
        key: "red",
        label: "s9v2UltimateRed",
        image: mouseS9V2UltimateRed,
      },
      {
        key: "silver",
        label: "s9v2UltimateSilver",
        image: mouseS9V2UltimateSilver,
      },
    ],
    defaultColor: "bingchuangblue",
  },
  "S9V2 Turbo": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9ultraWhite", image: mouseS9UltraWhite },
      { key: "black", label: "s9ultraBlack", image: mouseS9UltraBlack },
    ],
    defaultColor: "white",
  },
  "S9 Ultimate": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "silver", label: "s9ultraSilver", image: mouseS9UltraSilver },
      { key: "red", label: "s9ultraRed", image: mouseS9UltraRed },
    ],
    defaultColor: "silver",
  },
  // S9 Pro（贝盈方案）外观配色：沿用 S9 Pro v2 的素材与文案
  "S9 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "s9proBlack", image: mouseS9ProBlack },
      { key: "white", label: "s9proWhite", image: mouseS9ProWhite },
      { key: "red", label: "s9proRed", image: mouseS9ProRed },
      { key: "silver", label: "s9proSilver", image: mouseS9ProSilver },
      {
        key: "blackpurple",
        label: "s9proBlackpurple",
        image: mouseS9ProBlackpurple,
      },
    ],
    defaultColor: "black",
  },

  // S9 Max（贝盈方案）
  "S9 Max": {
    deviceType: DeviceType.Mouse,
    colors: [{ key: "cyan", label: "s9maxCyan", image: mouseS9MaxCyan }],
    defaultColor: "cyan",
  },

  // S9 Ultra（贝盈方案）
  "S9 Ultra": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9ultraWhite", image: mouseS9UltraWhite },
      { key: "red", label: "s9ultraRed", image: mouseS9UltraRed },
      { key: "black", label: "s9ultraBlack", image: mouseS9UltraBlack },
      { key: "silver", label: "s9ultraSilver", image: mouseS9UltraSilver },
      {
        key: "blackpurple",
        label: "s9ultraBlackpurple",
        image: mouseS9UltraBlackpurple,
      },
    ],
    defaultColor: "black",
  },

  "S9 Ultra+": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "silver", label: "s9ultraSilver", image: mouseS9UltraSilver },
    ],
    defaultColor: "silver",
  },

  "X23 Zhuoyue": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "x23ZhuoyueWhite", image: mouseX23ZhuoyueWhite },
      {
        key: "berryred",
        label: "x23ZhuoyueBerryRed",
        image: mouseX23ZhuoyueBerryRed,
      },
      {
        key: "light-blue",
        label: "x23ZhuoyueLightBlue",
        image: mouseX23ZhuoyueLightBlue,
      },
    ],
    defaultColor: "white",
  },

  "X23 星闪": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "berryred", label: "x23BerryRed", image: mouseX23BerryRed },
    ],
    defaultColor: "berryred",
  },
  "X23 Max": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "x23MaxWhite", image: mouseX23MaxWhite },
      { key: "berryred", label: "x23MaxBerryRed", image: mouseX23MaxBerryRed },
    ],
    defaultColor: "white",
  },

  // S7 Pro（贝盈方案）
  "S7 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [{ key: "white", label: "s7proWhite", image: mouseS7ProWhite }],
    defaultColor: "white",
  },

  // S7（富芮坤方案）
  S7: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s7White", image: mouseS7White },
      { key: "berryred", label: "s7BerryRed", image: mouseS7BerryRed },
      { key: "s7green", label: "s7Green", image: mouseS7Green },
    ],
    defaultColor: "white",
  },

  "S7 Plus": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s7plusWhite", image: mouseS7PlusWhite },
      { key: "black", label: "s7plusBlack", image: mouseS7PlusBlack },
    ],
    defaultColor: "white",
  },

  S2: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s2White", image: mouseS2White },
      { key: "black", label: "s2Black", image: mouseS2Black },
      { key: "blue", label: "s2Blue", image: mouseS2Blue },
      { key: "berryred", label: "s2BerryRed", image: mouseS2BerryRed },
      { key: "green", label: "s2Green", image: mouseS2Green },
    ],
    defaultColor: "white",
  },

  // S7 SE（富芮坤方案）
  "S7 SE": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s7seWhite", image: mouseS7seWhite },
      { key: "berryred", label: "s7seBerryRed", image: mouseS7seBerryRed },
      { key: "s7green", label: "s7seGreen", image: mouseS7seGreen },
    ],
    defaultColor: "white",
  },

  // S7 Max（贝盈方案）
  "S7 Max": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s7maxWhite", image: mouseS7MaxWhite },
      { key: "black", label: "s7maxBlackGold", image: mouseS7MaxBlackGold },
      {
        key: "jiangguohong",
        label: "s7maxJiangGuoHong",
        image: mouseS7MaxJiangGuoHong,
      },
    ],
    defaultColor: "white",
  },

  "X23 SE": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "x23SEWhite", image: mouseX23SEWhite },
      { key: "black", label: "x23SEBlack", image: mouseX23SEBlack },
      {
        key: "lightgreen",
        label: "x23SELightGreen",
        image: mouseX23SELightGreen,
      },
      { key: "pink", label: "x23SEPink", image: mouseX23SEPink },
      { key: "berryred", label: "x23SEBerryRed", image: mouseX23SEBerryRed },
    ],
    defaultColor: "white",
  },

  X23SE: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "x23SEWhite", image: mouseX23SEWhite },
      { key: "black", label: "x23SEBlack", image: mouseX23SEBlack },
      {
        key: "lightgreen",
        label: "x23SELightGreen",
        image: mouseX23SELightGreen,
      },
      { key: "pink", label: "x23SEPink", image: mouseX23SEPink },
      { key: "berryred", label: "x23SEBerryRed", image: mouseX23SEBerryRed },
    ],
    defaultColor: "white",
  },
  // S7 Ultra（贝盈方案）
  "S7 Ultra": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s7ultraWhite", image: mouseS7UltraWhite },
      { key: "black", label: "s7ultraBlackGold", image: mouseS7UltraBlackGold },
      {
        key: "jiangguohong",
        label: "s7ultraJiangGuoHong",
        image: mouseS7UltraJiangGuoHong,
      },
    ],
    defaultColor: "white",
  },

  "X23 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "x23ProWhite", image: mouseX23ProWhite },
      { key: "black", label: "x23ProBlack", image: mouseX23ProBlack },
      { key: "blue", label: "x23ProBlue", image: mouseX23ProBlue },
      {
        key: "jiangguohong",
        label: "x23ProJiangGuoHong",
        image: mouseX23ProJiangGuoHong,
      },
      {
        key: "shumeipink",
        label: "x23ProShuMeiPink",
        image: mouseX23ProShuMeiPink,
      },
      {
        key: "saiboxiongmao",
        label: "x23ProCyberPanda",
        image: mousex23ProCyberPanda,
      },
    ],
    defaultColor: "white",
  },

  X23Pro: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "x23ProWhite", image: mouseX23ProWhite },
      { key: "black", label: "x23ProBlack", image: mouseX23ProBlack },
      { key: "blue", label: "x23ProBlue", image: mouseX23ProBlue },
      {
        key: "jiangguohong",
        label: "x23ProJiangGuoHong",
        image: mouseX23ProJiangGuoHong,
      },
      {
        key: "shumeipink",
        label: "x23ProShuMeiPink",
        image: mouseX23ProShuMeiPink,
      },
      {
        key: "saiboxiongmao",
        label: "x23ProCyberPanda",
        image: mousex23ProCyberPanda,
      },
    ],
    defaultColor: "white",
  },

  S9: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "s9White", image: mouseS9White },
      { key: "black", label: "s9Black", image: mouseS9Black },
    ],
    defaultColor: "white",
  },

  "X23 Carbon": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "x23CarbonBlack", image: mouseX23CarbonBlack },
      {
        key: "qianlan",
        label: "x23CarbonQianlan",
        image: mouseX23CarbonQianlan,
      },
      { key: "silver", label: "x23CarbonSilver", image: mouseX23CarbonSilver },
    ],
    defaultColor: "black",
  },

  "X23L Carbon": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "x23LCarbonBlack", image: mouseX23LCarbonBlack },
      {
        key: "silver",
        label: "x23LCarbonSilver",
        image: mouseX23LCarbonSilver,
      },
    ],
    defaultColor: "black",
  },
  A6: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "a6XiangYaWhite", image: mouseA6XiangYaWhite },
    ],
    defaultColor: "white",
  },

  "A6 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      {
        key: "white",
        label: "a6ProXiangYaWhite",
        image: mouseA6ProXiangYaWhite,
      },
      {
        key: "bingchuangblue",
        label: "a6ProBingChuanBlue",
        image: mouseA6ProBingChuanBlue,
      },
      {
        key: "black",
        label: "a6ProJingdianBlack",
        image: mouseA6ProJingdianBlack,
      },
      {
        key: "yinghuapink",
        label: "a6ProYingHuaPink",
        image: mouseA6ProYingHuaPink,
      },
    ],
    defaultColor: "white",
  },

  "A6 Max": {
    deviceType: DeviceType.Mouse,
    colors: [
      {
        key: "white",
        label: "a6MaxXiangYaWhite",
        image: mouseA6MaxXiangYaWhite,
      },
    ],
    defaultColor: "white",
  },

  "G2SE A": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "g2seaWhite", image: mouseG2SEAWhite },
      { key: "black", label: "g2seaBlack", image: mouseG2SEABlack },
    ],
    defaultColor: "white",
  },

  "G2 SE": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "g2seaWhite", image: mouseG2SEAWhite },
      { key: "black", label: "g2seaBlack", image: mouseG2SEABlack },
    ],
    defaultColor: "white",
  },

  "A7 SE": {
    deviceType: DeviceType.Mouse,
    colors: [{ key: "white", label: "a7SEWhite", image: mouseA7SEWhite }],
    defaultColor: "white",
  },

  A7: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "a7White", image: mouseA7White },
      { key: "black", label: "a7Black", image: mouseA7Black },
    ],
    defaultColor: "white",
  },

  "A7 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "a7ProWhite", image: mouseA7ProWhite },
      { key: "black", label: "a7ProBlack", image: mouseA7ProBlack },
    ],
    defaultColor: "white",
  },

  Alpha7: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "alpha7White", image: mouseAlpha7White },
      { key: "black", label: "alpha7Black", image: mouseAlpha7Black },
      { key: "shumeipink", label: "alpha7Pink", image: mouseAlpha7Pink },
    ],
    defaultColor: "white",
  },

  Alpha6: {
    deviceType: DeviceType.Mouse,
    colors: [
      {
        key: "blackwhite",
        label: "alpha6Blackwhite",
        image: mouseAlpha6Blackwhite,
      },
      {
        key: "blackorange",
        label: "alpha6Blackorange",
        image: mouseAlpha6Blackorange,
      },
      {
        key: "berryred",
        label: "alpha6Berryred",
        image: mouseAlpha6Berryred,
      },
    ],
    defaultColor: "blackwhite",
  },
  "Z7 Max": {
    deviceType: DeviceType.Mouse,
    colors: [{ key: "black", label: "z7MaxBlack", image: mouseZ7MaxBlack }],
    defaultColor: "black",
  },

  z7max: {
    deviceType: DeviceType.Mouse,
    colors: [{ key: "black", label: "z7MaxBlack", image: mouseZ7MaxBlack }],
    defaultColor: "black",
  },

  "GS02 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "gs02ProJiYeBlack", image: mouseGS02ProJiYeBlack },
      {
        key: "white",
        label: "gs02ProYueGuangBai",
        image: mouseGS02ProYueGuangBai,
      },
    ],
    defaultColor: "black",
  },

  "E7 V2": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "e7V2Black", image: mouseE7V2Black },
      {
        key: "white",
        label: "e7V2White",
        image: mouseE7V2White,
      },
    ],
    defaultColor: "black",
  },
  E7: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e7White", image: mouseE7White },
      { key: "black", label: "e7Black", image: mouseE7Black },
      { key: "berryred", label: "e7BerryRed", image: mouseE7BerryRed },
      { key: "lightgreen", label: "e7LemonGreen", image: mouseE7LemonGreen },
      { key: "blue", label: "e7SkyBlue", image: mouseE7SkyBlue },
      { key: "red", label: "e7FireRed", image: mouseE7FireRed },
      {
        key: "foggywhite",
        label: "e7Foggywhite",
        image: mouseE7Foggywhite,
      },
    ],
    defaultColor: "white",
  },
  "E7 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "black", label: "e7ProBlack", image: mouseE7ProBlack },
      { key: "white", label: "e7ProWhite", image: mouseE7ProWhite },
      { key: "berryred", label: "e7ProBerryRed", image: mouseE7ProBerryRed },
    ],
    defaultColor: "white",
  },
  "E7 V2 Max": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e7V2MaxWhite", image: mouseE7V2MaxWhite },
      { key: "black", label: "e7V2MaxBlack", image: mouseE7V2MaxBlack },
      {
        key: "berryred",
        label: "e7V2MaxBerryRed",
        image: mouseE7V2MaxBerryRed,
      },
    ],
    defaultColor: "white",
  },
  E9: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e9White", image: mouseE9White },
      { key: "black", label: "e9Black", image: mouseE9Black },
      { key: "berryred", label: "e9BerryRed", image: mouseE9BerryRed },
      { key: "lightgreen", label: "e9LemonGreen", image: mouseE9LemonGreen },
    ],
    defaultColor: "white",
  },
  "E9 Carbon": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e9White", image: mouseE9CarbonWhite },
      { key: "black", label: "e9Black", image: mouseE9CarbonBlack },
      { key: "berryred", label: "e9BerryRed", image: mouseE9CarbonBerryRed },
    ],
    defaultColor: "white",
  },
  "E9 Pro Carbon": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e9White", image: mouseE9CarbonWhite },
      { key: "black", label: "e9Black", image: mouseE9CarbonBlack },
      { key: "berryred", label: "e9BerryRed", image: mouseE9CarbonBerryRed },
    ],
    defaultColor: "white",
  },
  E11: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e11White", image: mouseE11White },
      { key: "berryred", label: "e11BerryRed", image: mouseE11BerryRed },
      { key: "yinghuapink", label: "e11SakuraPink", image: mouseE11SakuraPink },
    ],
    defaultColor: "white",
  },
  "E11 Pro": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e11White", image: mouseE11White },
      { key: "berryred", label: "e11BerryRed", image: mouseE11BerryRed },
      {
        key: "yinghuapink",
        label: "e11SakuraPink",
        image: mouseE11SakuraPink,
      },
    ],
    defaultColor: "white",
  },
  "E11 V2": {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "e11V2White", image: mouseE11V2White },
      { key: "berryred", label: "e11V2BerryRed", image: mouseE11V2BerryRed },
    ],
    defaultColor: "white",
  },
  G5: {
    deviceType: DeviceType.Mouse,
    colors: [
      { key: "white", label: "g5XiangBinBlue", image: mouseG5XiangBinBlue },
      { key: "black", label: "g5JinShuBlack", image: mouseG5JinShuBlack },
      { key: "red", label: "g5KaiJiaRed", image: mouseG5KaiJiaRed },
    ],
    defaultColor: "white",
  },
  // ==================== 键盘设备 ====================
  X87: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "x87White", image: keyboardX87White },
      {
        key: "baifenjianbian",
        label: "x87Baifenjianbian",
        image: keyboardX87Baifenjianbian,
      },
      { key: "duantan", label: "x87Duantan", image: keyboardX87Duantan },
      { key: "fushihui", label: "x87Fushihui", image: keyboardX87Fushihui },
      {
        key: "jingmihaiyang",
        label: "x87Jingmihaiyang",
        image: keyboardX87Jingmihaiyang,
      },
      { key: "piwen", label: "x87Piwen", image: keyboardX87Piwen },
      { key: "piwenbai", label: "x87Piwenbai", image: keyboardX87Piwenbai },
      { key: "qingti", label: "x87Qingti", image: keyboardX87Qingti },
      {
        key: "tianxinfen",
        label: "x87Tianxinfen",
        image: keyboardX87Tianxinfen,
      },
      { key: "weichen", label: "x87Weichen", image: keyboardX87Weichen },
      { key: "wutou", label: "x87Wutou", image: keyboardX87Wutou },
      {
        key: "xueshanjianbian",
        label: "x87Xueshanjianbian",
        image: keyboardX87Xueshanjianbian,
      },
      {
        key: "blackpink",
        label: "x87Blackpink",
        image: keyboardX87Blackpink,
      },
      {
        key: "zheying",
        label: "x87Zheying",
        image: keyboardX87Zheying,
      },
      {
        key: "chiyanhong",
        label: "x87FlameRed",
        image: keyboardx87FlameRed,
      },
    ],
    defaultColor: "white",
  },
  "X87 HE": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "blackpink",
        label: "x87heBlackpink",
        image: keyboardX87heBlackpink,
      },
      { key: "blue", label: "x87heBlue", image: keyboardX87heBlue },
      { key: "duantan", label: "x87heDuantan", image: keyboardX87heDuantan },
      { key: "white", label: "x87heWhite", image: keyboardX87heWhite },
    ],
    defaultColor: "blackpink",
  },
  "Alpha 87": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "silver", label: "alpha87Silver", image: keyboardAlpha87Silver },
    ],
    defaultColor: "silver",
  },
  "DEEP68 Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "deep68White", image: keyboardDeep68White },
      { key: "pink", label: "deep68Pink", image: keyboardDeep68Pink },
    ],
    defaultColor: "white",
  },
  DEEP68: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "deep68White", image: keyboardDeep68White },
      { key: "pink", label: "deep68Pink", image: keyboardDeep68Pink },
    ],
    defaultColor: "white",
  },
  battle68: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "battle68Black", image: keyboardBattle68Black },
      {
        key: "blackred",
        label: "battle68Blackred",
        image: keyboardBattle68Blackred,
      },
      {
        key: "blackyellow",
        label: "battle68Blackyellow",
        image: keyboardBattle68Blackyellow,
      },
      {
        key: "weichen",
        label: "battle68Weichen",
        image: keyboardBattle68Weichen,
      },
    ],
    defaultColor: "black",
  },
  "Tank68 HE": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "white",
        label: "tank68Whitecontourline",
        image: keyboardTank68Whitecontourline,
      },
      { key: "black", label: "tank68Black", image: keyboardTank68Black },
      {
        key: "blackred",
        label: "tank68Blackredcontourline",
        image: keyboardTank68Blackredcontourline,
      },
      {
        key: "blackcontourline",
        label: "tank68Blackcontourline",
        image: keyboardTank68Blackcontourline,
      },
    ],
    defaultColor: "white",
  },
  "X98 (8K) Touch": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "purple", label: "x98Purple", image: keyboardX98Purple },
      { key: "taofen", label: "x98Taofen", image: keyboardX98Taofen },
      {
        key: "yunjianlan",
        label: "x98Yunjianlan",
        image: keyboardX98Yunjianlan,
      },
      {
        key: "zheyingzhiguang",
        label: "x98Zheyingzhiguang",
        image: keyboardX98Zheyingzhiguang,
      },
    ],
    defaultColor: "purple",
  },
  "X98 (1K) Touch": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "purple", label: "x98Purple", image: keyboardX98Purple },
      { key: "taofen", label: "x98Taofen", image: keyboardX98Taofen },
      {
        key: "yunjianlan",
        label: "x98Yunjianlan",
        image: keyboardX98Yunjianlan,
      },
      {
        key: "zheyingzhiguang",
        label: "x98Zheyingzhiguang",
        image: keyboardX98Zheyingzhiguang,
      },
    ],
    defaultColor: "purple",
  },
  "X98 (1K)": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "purple", label: "x98Purple", image: keyboardX98Purple },
      { key: "taofen", label: "x98Taofen", image: keyboardX98Taofen },
      {
        key: "yunjianlan",
        label: "x98Yunjianlan",
        image: keyboardX98Yunjianlan,
      },
      {
        key: "zheyingzhiguang",
        label: "x98Zheyingzhiguang",
        image: keyboardX98Zheyingzhiguang,
      },
    ],
    defaultColor: "purple",
  },
  SMART875: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "smart875Black", image: keyboardSmart875Black },
      { key: "red", label: "smart875Red", image: keyboardSmart875Red },
      {
        key: "silvery",
        label: "smart875Silvery",
        image: keyboardSmart875Silvery,
      },
    ],
    defaultColor: "black",
  },
  "DEEP80 MAX": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "deep80maxWhite", image: keyboardDeep80MaxWhite },
      {
        key: "berryred",
        label: "deep80maxBerryRed",
        image: keyboardDeep80MaxBerryRed,
      },
      {
        key: "berryredTranslucent",
        label: "deep80maxBerryRedTranslucent",
        image: keyboardDeep80MaxBerryRedTranslucent,
      },
    ],
    defaultColor: "white",
  },
  DK80: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "dk80White", image: keyboardDk80White },
      {
        key: "whitepink",
        label: "dk80Whitepink",
        image: keyboardDk80Whitepink,
      },
      { key: "zheying", label: "dk80Zheying", image: keyboardDk80Zheying },
      {
        key: "whitedenggaoxian3",
        label: "dk80Denggaoxianwhite",
        image: keyboardDk80Denggaoxianwhite,
      },
      { key: "weichen", label: "dk80Weichen", image: keyboardDk80Weichen },
      {
        key: "white2",
        label: "dk80Russiawhite",
        image: keyboardDk80Russiawhite,
      },
      {
        key: "weichen2",
        label: "dk80Russiaweichen",
        image: keyboardDk80Russiaweichen,
      },
    ],
    defaultColor: "white",
  },
  "DEEP80 Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "deep80proWhite", image: keyboardDeep80ProWhite },
      {
        key: "berryred",
        label: "deep80proBerryRed",
        image: keyboardDeep80ProBerryRed,
      },
      {
        key: "berryredTranslucent",
        label: "deep80proBerryRedTranslucent",
        image: keyboardDeep80ProBerryRedTranslucent,
      },
    ],
    defaultColor: "white",
  },
  DK68: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "dk68Black", image: keyboardDk68Black },
      { key: "white", label: "dk68White", image: keyboardDk68White },
      { key: "berryred", label: "dk68Berryred", image: keyboardDk68Berryred },
    ],
    defaultColor: "black",
  },
  "DK68 Star": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "dk68StarBlack", image: keyboardDk68StarBlack },
      { key: "white", label: "dk68StarWhite", image: keyboardDk68StarWhite },
      {
        key: "berryred",
        label: "dk68StarBerryred",
        image: keyboardDk68StarBerryred,
      },
      {
        key: "zheying",
        label: "dk68StarZheying",
        image: keyboardDk68StarZheying,
      },
    ],
    defaultColor: "black",
  },
  "DK63 Star": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "dk68StarBlack", image: keyboardDk68StarBlack },
      { key: "white", label: "dk68StarWhite", image: keyboardDk68StarWhite },
      {
        key: "berryred",
        label: "dk68StarBerryred",
        image: keyboardDk68StarBerryred,
      },
      {
        key: "zheying",
        label: "dk68StarZheying",
        image: keyboardDk68StarZheying,
      },
    ],
    defaultColor: "black",
  },
  "DK68 V2": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "dk68v2White", image: keyboardDk68V2White },
      {
        key: "black",
        label: "dk68v2Foggyblack",
        image: keyboardDk68V2Foggyblack,
      },
      {
        key: "piwenbai",
        label: "dk68v2Foggywhite",
        image: keyboardDk68V2Foggywhite,
      },
      {
        key: "pink",
        label: "dk68v2Foggypink",
        image: keyboardDk68V2Foggypink,
      },
    ],
    defaultColor: "piwenbai",
  },
  "DK68 Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "dk68proBlack", image: keyboardDk68ProBlack },
      { key: "white", label: "dk68proWhite", image: keyboardDk68ProWhite },
      {
        key: "berryred",
        label: "dk68proBerryred",
        image: keyboardDk68ProBerryred,
      },
    ],
    defaultColor: "black",
  },
  "DK68-Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "black",
        label: "eweadndk68proBlack",
        image: keyboardEweadnDk68ProBlack,
      },
      {
        key: "white",
        label: "eweadndk68proWhite",
        image: keyboardEweadnDk68ProWhite,
      },
      {
        key: "berryred",
        label: "eweadndk68proBerryred",
        image: keyboardEweadnDk68ProBerryred,
      },
    ],
    defaultColor: "black",
  },
  DK63: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "dk63Black", image: keyboardDk63Black },
      { key: "white", label: "dk63White", image: keyboardDk63White },
      { key: "berryred", label: "dk63Berryred", image: keyboardDk63Berryred },
    ],
    defaultColor: "black",
  },
  "DK63 V2": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "white",
        label: "dk63v2WhiteSidePrinted",
        image: keyboardDk63V2WhiteSidePrinted,
      },
      {
        key: "foggywhite",
        label: "dk63v2WhiteMistSheer",
        image: keyboardDk63V2WhiteMistSheer,
      },
      {
        key: "whitecarbon",
        label: "dk63v2WhiteCarbonPattern",
        image: keyboardDk63V2WhiteCarbonPattern,
      },
      {
        key: "whitedenggaoxian3",
        label: "dk63v2ContourLine",
        image: keyboardDk63V2ContourLine,
      },
      {
        key: "pink",
        label: "dk63v2PinkSidePrinted",
        image: keyboardDk63V2PinkSidePrinted,
      },
      {
        key: "blackgreygradient",
        label: "dk63v2BlackSidePrinted",
        image: keyboardDk63V2BlackSidePrinted,
      },
      {
        key: "black",
        label: "dk63v2BlackFrontPrinted",
        image: keyboardDk63V2BlackFrontPrinted,
      },
      {
        key: "duantan",
        label: "dk63v2BlackCarbonPattern",
        image: keyboardDk63V2BlackCarbonPattern,
      },
      {
        key: "zheying",
        label: "dk63v2FoldingShadow",
        image: keyboardDk63V2FoldingShadow,
      },
    ],
    defaultColor: "black",
  },
  ES98: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "blackpurple",
        label: "es98Blackpurple",
        image: keyboardEs98Blackpurple,
      },
      {
        key: "tengwangge",
        label: "es98Tengwangge",
        image: keyboardEs98Tengwangge,
      },
      {
        key: "whiteblue",
        label: "es98Whiteblue",
        image: keyboardEs98Whiteblue,
      },
      {
        key: "whitepink",
        label: "es98Whitepink",
        image: keyboardEs98Whitepink,
      },
    ],
    defaultColor: "blackpurple",
  },
  "X75 Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "x75proWhite", image: keyboardX75ProWhite },
      {
        key: "blackpink",
        label: "x75proBlackpink",
        image: keyboardX75ProBlackpink,
      },
      {
        key: "grapepurple",
        label: "x75proGrapePurple",
        image: keyboardX75ProGrapePurple,
      },
      {
        key: "jiangguohong",
        label: "x75proJiangGuoHong",
        image: keyboardX75ProJiangGuoHong,
      },
      {
        key: "moyingjianbiandenggaoxian3",
        label: "x75proMoYingJianBianDengGaoXian3",
        image: keyboardX75ProMoYingJianBianDengGaoXian3,
      },
      {
        key: "pinkgradient",
        label: "x75proPinkGradient",
        image: keyboardX75ProPinkGradient,
      },
      {
        key: "whitedenggaoxian3",
        label: "x75proWhiteDengGaoXian3",
        image: keyboardX75ProWhiteDengGaoXian3,
      },
    ],
    defaultColor: "white",
  },
  X75GC: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "silver", label: "x75gcSilver", image: keyboardX75GcSilverscreen },
    ],
    defaultColor: "silver",
    screenWidth: 240,
    screenHeight: 135,
  },
  "X75-Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "black",
        label: "x75proRussiablack",
        image: keyboardX75ProRussiablack,
      },
    ],
    defaultColor: "black",
  },
  "X75 Pro Screen": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "white",
        label: "x75v2proWhite",
        image: keyboardX75V2ProWhite,
      },
      {
        key: "blackpink",
        label: "x75v2proBlackpink",
        image: keyboardX75V2ProBlackpink,
      },
      {
        key: "grapepurple",
        label: "x75v2proGrapePurple",
        image: keyboardX75V2ProGrapePurple,
      },
      {
        key: "jiangguohong",
        label: "x75v2proJiangGuoHong",
        image: keyboardX75V2ProJiangGuoHong,
      },
      {
        key: "moyingjianbiandenggaoxian3",
        label: "x75v2proMoYingJianBianDengGaoXian3",
        image: keyboardX75V2ProMoYingJianBianDengGaoXian3,
      },
      {
        key: "pinkgradient",
        label: "x75v2proPinkGradient",
        image: keyboardX75V2ProPinkGradient,
      },
      {
        key: "whitedenggaoxian3",
        label: "x75v2proWhiteDengGaoXian3",
        image: keyboardX75V2ProWhiteDengGaoXian3,
      },
    ],
    defaultColor: "white",
    screenWidth: 135,
    screenHeight: 240,
  },
  "X75 V3": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "x75v3Black", image: keyboardX75V3Black },
      { key: "silver", label: "x75v3Silver", image: keyboardX75V3Silver },
    ],
    defaultColor: "silver",
  },
  "X75 Ultra": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "x75ultraBlack", image: keyboardX75UltraBlack },
      {
        key: "silverred",
        label: "x75ultraSilverRed",
        image: keyboardX75UltraSilver,
      },
    ],
    defaultColor: "silverred",
  },
  Gamma75: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "pink", label: "exxGamma75Pink", image: keyboardExxGamma75Pink },
      {
        key: "silver",
        label: "exxGamma75Silver",
        image: keyboardExxGamma75Silver,
      },
      {
        key: "black",
        label: "exxGamma75Black",
        image: keyboardExxGamma75Black1,
      },
      {
        key: "silverred",
        label: "exxGamma75SilverRed",
        image: keyboardExxGamma75Silver1,
      },
      {
        key: "featherred",
        label: "exxGamma75FeatherRed",
        image: keyboardExxGamma75FeatherRed,
      },
      {
        key: "feathergreen",
        label: "exxGamma75FeatherGreen",
        image: keyboardExxGamma75FeatherGreen,
      },
      {
        key: "featherpurple",
        label: "exxGamma75FeatherPurple",
        image: keyboardExxGamma75FeatherPurple,
      },
      {
        key: "featherblack",
        label: "exxGamma75FeatherBlack",
        image: keyboardExxGamma75FeatherBlack,
      },
    ],
    defaultColor: "pink",
  },
  "Gamma75 Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "black",
        label: "exxGamma75proBlack",
        image: keyboardExxGamma75proBlack,
      },
      {
        key: "green",
        label: "exxGamma75proGreen",
        image: keyboardExxGamma75proGreen,
      },
      {
        key: "purple",
        label: "exxGamma75proPurple",
        image: keyboardExxGamma75proPurple,
      },
      {
        key: "red",
        label: "exxGamma75proRed",
        image: keyboardExxGamma75proRed,
      },
      {
        key: "silverTwoTone",
        label: "exxGamma75proSilverTwoTone",
        image: keyboardExxGamma75proSilverTwoTone,
      },
      {
        key: "silvery",
        label: "exxGamma75proSilvery",
        image: keyboardExxGamma75proSilvery,
      },
    ],
    defaultColor: "silvery",
  },
  "Gamma75 Pro Evo": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "knifeBlackFog",
        label: "exxGamma75proEvoKnifeBlackFog",
        image: keyboardExxGamma75proEvoKnifeBlackFog,
      },
      {
        key: "knifeBlackThreePiece",
        label: "exxGamma75proEvoKnifeBlackThreePiece",
        image: keyboardExxGamma75proEvoKnifeBlackThreePiece,
      },
      {
        key: "knifeGreen",
        label: "exxGamma75proEvoKnifeGreen",
        image: keyboardExxGamma75proEvoKnifeGreen,
      },
      {
        key: "knifeSilverSide",
        label: "exxGamma75proEvoKnifeSilverSide",
        image: keyboardExxGamma75proEvoKnifeSilverSidePrinted,
      },
      {
        key: "knifeSilverTwoTone",
        label: "exxGamma75proEvoKnifeSilverTwoTone",
        image: keyboardExxGamma75proEvoKnifeSilverTwoTone,
      },
    ],
    defaultColor: "knifeSilverTwoTone",
  },
  "Gamma75 Ultra": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "silvery",
        label: "exxGamma75ultraSilvery",
        image: keyboardExxGamma75ultraSilvery,
      },
    ],
    defaultColor: "silvery",
  },
  ES68: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "black",
        label: "es68Black",
        image: keyboardEs68Black,
      },
      {
        key: "white",
        label: "es68White",
        image: keyboardEs68White,
      },
      {
        key: "pink",
        label: "es68Pink",
        image: keyboardEs68Pink,
      },
    ],
    defaultColor: "es68Black",
  },
  /** ES68 TIANYI 洛天依联名（VID 0x1ca6 / PID 0x1c50，固件 es68-luotianyi / es68lite-luotianyi） */
  "ES68 TIANYI": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "luotianyi",
        label: "es68Luotianyi",
        image: keyboardEs68Luotianyi,
      },
    ],
    defaultColor: "luotianyi",
  },
  "ES68 EVO (Full)": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "black",
        label: "es68Black",
        image: keyboardEs68Black,
      },
      {
        key: "white",
        label: "es68White",
        image: keyboardEs68White,
      },
      {
        key: "pink",
        label: "es68Pink",
        image: keyboardEs68Pink,
      },
      {
        key: "luotianyi",
        label: "es68Luotianyi",
        image: keyboardEs68Luotianyi,
      },
    ],
    defaultColor: "es68Black",
  },
  "ES68 Lite": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "black",
        label: "es68liteBlack",
        image: keyboardES68LiteBlack,
      },
      {
        key: "silver",
        label: "es68liteSilver",
        image: keyboardES68LiteSilver,
      },
    ],
    defaultColor: "black",
  },
  M98: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "fendiye", label: "m98FenDiYe", image: keyboardM98FenDiYe },
      {
        key: "leitaocijianmao",
        label: "m98LeiTaoCiJianMao",
        image: keyboardM98LeiTaoCiJianMao,
      },
    ],
    defaultColor: "fendiye",
  },
  "M98 Screen": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "JingTou", label: "m98TFTJingTou", image: keyboardM98TFTJingTou },
    ],
    defaultColor: "JingTou",
    screenWidth: 428,
    screenHeight: 142,
  },
  "M98 (8K)": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "JingTou", label: "m98TFTJingTou", image: keyboardM98TFTJingTou },
    ],
    defaultColor: "JingTou",
    screenWidth: 428,
    screenHeight: 142,
  },
  V80: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "default", label: "v80Default", image: keyboardV80Default },
    ],
    defaultColor: "default",
  },
  V102: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "default", label: "v102Default", image: keyboardV102Default },
    ],
    defaultColor: "default",
  },
  "X87 V2": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "blackpink",
        label: "x87v2Blackberry",
        image: keyboardx87v2Blackberry,
      },
      {
        key: "baifenjianbian",
        label: "x87v2Cherryblossompink",
        image: keyboardx87v2Cherryblossompink,
      },
      {
        key: "white",
        label: "x87v2Contourline",
        image: keyboardx87v2Contourline,
      },
      {
        key: "weichen",
        label: "x87v2Dust",
        image: keyboardx87v2Dust,
      },
      {
        key: "zheying",
        label: "x87v2Shadowfold",
        image: keyboardx87v2Shadowfold,
      },
    ],
    defaultColor: "blackpink",
  },
  X87S: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "white",
        label: "x87sWhitedenggaoxian",
        image: keyboardX87sWhitedenggaoxian,
      },
      {
        key: "blackpink",
        label: "x87sBlackpink",
        image: keyboardX87sBlackpink,
      },
      {
        key: "yinghuapink",
        label: "x87sSakurapink",
        image: keyboardX87sSakurapink,
      },
      { key: "weichen", label: "x87sWeichen", image: keyboardX87sWeichen },
      { key: "zheying", label: "x87sZheying", image: keyboardX87sZheying },
      {
        key: "luotianyi",
        label: "x87sLuotianyi",
        image: keyboardX87sLuotianyi,
      },
    ],
    defaultColor: "white",
  },
  /** X87S 洛天依联名（VID 0x3151 / PID 0x504e，HID productName X87S） */
  "X87S TIANYI": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "luotianyi",
        label: "x87sLuotianyi",
        image: keyboardX87sLuotianyi,
      },
    ],
    defaultColor: "luotianyi",
  },
  "ES68 EVO": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "pink", label: "es68evoPink", image: keyboardES68EVOPink },
      { key: "black", label: "es68evoBlack", image: keyboardES68EVOBlack },
      { key: "silver", label: "es68evoSilver", image: keyboardES68EVOSilver },
    ],
    defaultColor: "pink",
  },
  "MUSE M80": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "blue",
        label: "m80_1k_blue",
        image: keyboardM80Blue,
      },
      {
        key: "white",
        label: "m80_1k_white",
        image: keyboardM80White,
      },
    ],
    defaultColor: "blue",
  },
  M71: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "lipstickDot",
        label: "m71_lipstickDot",
        image: keyboardM71LipstickDot,
      },
      {
        key: "cuteBearLiquidFoundation",
        label: "m71_cuteBearLiquidFoundation",
        image: keyboardM71CuteBearLiquidFoundation,
      },
      {
        key: "lipstickCuteLittleBear",
        label: "m71_lipstickCuteLittleBear",
        image: keyboardM71LipstickCuteLittleBear,
      },
      {
        key: "liquidFoundationDots",
        label: "m71_liquidFoundationDots",
        image: keyboardM71LiquidFoundationDots,
      },
    ],
    defaultColor: "lipstickDot",
  },
  T87: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "jiguangwhite",
        label: "t87JiGuangWhite",
        image: keyboardT87JiGuangWhite,
      },
      { key: "moyunhui", label: "t87MoYunHui", image: keyboardT87MoYunHui },
      {
        key: "ningyepink",
        label: "t87NingYePink",
        image: keyboardT87NingYePink,
      },
      {
        key: "taoyuewhite",
        label: "t87TaoYueWhite",
        image: keyboardT87TaoYueWhite,
      },
      {
        key: "yuntianblue",
        label: "t87YunTianBlue",
        image: keyboardT87YunTianBlue,
      },
    ],
    defaultColor: "jiguangwhite",
  },
  X75V2: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "whiteblue",
        label: "x75v2Whiteblue",
        image: keyboardX75V2Whiteblue,
      },
      {
        key: "blackyellow",
        label: "x75v2Blackyellow",
        image: keyboardX75V2Blackyellow,
      },
      {
        key: "zheying",
        label: "x75v2Zheying",
        image: keyboardX75V2Zheying,
      },
      {
        key: "whiteblue2",
        label: "x75v2Russianwhiteblue",
        image: keyboardX75V2Russianwhiteblue,
      },
      {
        key: "weichen",
        label: "x75v2Russianweichen",
        image: keyboardX75V2Russianweichen,
      },
    ],
    defaultColor: "whiteblue",
  },
  M75: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "pink",
        label: "m75Pink",
        image: keyboardM75Pink,
      },
      {
        key: "green",
        label: "m75Green",
        image: keyboardM75Green,
      },
      {
        key: "purple",
        label: "m75Purple",
        image: keyboardM75Purple,
      },
      {
        key: "cat",
        label: "m75Cat",
        image: keyboardM75Cat,
      },
    ],
    defaultColor: "m75Pink",
  },
  DK75: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "mistyWhite",
        label: "dk75MistyWhite",
        image: keyboardDk75MistyWhite,
      },
      {
        key: "mistyPurple",
        label: "dk75MistyPurple",
        image: keyboardDk75MistyPurple,
      },
      {
        key: "mistyPink",
        label: "dk75MistyPink",
        image: keyboardDk75MistyPink,
      },
    ],
    defaultColor: "mistyWhite",
  },
  "DK75 E": {
    deviceType: DeviceType.Keyboard,
    colors: [{ key: "white", label: "dk75EWhite", image: keyboardDk75EWhite }],
    defaultColor: "white",
  },
  "DK75 Pro": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "mistyWhite",
        label: "dk75ProMistyWhite",
        image: keyboardDk75ProMistyWhite,
      },
      {
        key: "mistyPurple",
        label: "dk75ProMistyPurple",
        image: keyboardDk75ProMistyPurple,
      },
      {
        key: "lakeGreen",
        label: "dk75ProLakeGreen",
        image: keyboardDk75ProLakeGreen,
      },
    ],
    defaultColor: "mistyWhite",
  },
  "DK75 Single": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "x75proWhite", image: keyboardX75ProWhite },
      {
        key: "blackpink",
        label: "x75proBlackpink",
        image: keyboardX75ProBlackpink,
      },
      {
        key: "grapepurple",
        label: "x75proGrapePurple",
        image: keyboardX75ProGrapePurple,
      },
      {
        key: "jiangguohong",
        label: "x75proJiangGuoHong",
        image: keyboardX75ProJiangGuoHong,
      },
      {
        key: "moyingjianbiandenggaoxian3",
        label: "x75proMoYingJianBianDengGaoXian3",
        image: keyboardX75ProMoYingJianBianDengGaoXian3,
      },
      {
        key: "pinkgradient",
        label: "x75proPinkGradient",
        image: keyboardX75ProPinkGradient,
      },
      {
        key: "whitedenggaoxian3",
        label: "x75proWhiteDengGaoXian3",
        image: keyboardX75ProWhiteDengGaoXian3,
      },
    ],
    defaultColor: "white",
  },
  DK108: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "white", label: "dk108White", image: keyboardDk108White },
      { key: "black", label: "dk108Black", image: keyboardDk108Black },
      {
        key: "bingDaoBlue",
        label: "dk108BingDaoBlue",
        image: keyboardDk108BingDaoBlue,
      },
      {
        key: "blackpink",
        label: "dk108BlackPink",
        image: keyboardDk108BlackPink,
      },
      {
        key: "qingTiGreen",
        label: "dk108QingTiGreen",
        image: keyboardDk108QingTiGreen,
      },
      {
        key: "taoYaoPink",
        label: "dk108TaoYaoPink",
        image: keyboardDk108TaoYaoPink,
      },
      {
        key: "tianKongBlue",
        label: "dk108TianKongBlue",
        image: keyboardDk108TianKongBlue,
      },
      {
        key: "tianShuiBi",
        label: "dk108TianShuiBi",
        image: keyboardDk108TianShuiBi,
      },
      { key: "weiChen", label: "dk108WeiChen", image: keyboardDk108WeiChen },
      {
        key: "xiangYuPurple",
        label: "dk108XiangYuPurple",
        image: keyboardDk108XiangYuPurple,
      },
      {
        key: "yingHuaPink",
        label: "dk108YingHuaPink",
        image: keyboardDk108YingHuaPink,
      },
    ],
    defaultColor: "white",
  },
  DK87: {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "baifenjianbian",
        label: "dk87BaiFenJianBian",
        image: keyboardDk87BaiFenJianBian,
      },
      { key: "black", label: "dk87Black", image: keyboardDk87Black },
      {
        key: "blackpink",
        label: "dk87BlackPink",
        image: keyboardDk87BlackPink,
      },
      { key: "qingti", label: "dk87QingTi", image: keyboardDk87QingTi },
      { key: "weichen", label: "dk87Weichen", image: keyboardDk87Weichen },
      { key: "white", label: "dk87White", image: keyboardDk87White },
    ],
    defaultColor: "baifenjianbian",
  },
  "DK63 Machine": {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "dk63Black", image: keyboardDk63Black },
      { key: "white", label: "dk63White", image: keyboardDk63White },
      { key: "berryred", label: "dk63Berryred", image: keyboardDk63Berryred },
    ],
    defaultColor: "black",
  },
  ZAP68: {
    deviceType: DeviceType.Keyboard,
    colors: [
      { key: "black", label: "zap68Black", image: keyboardZAP68Black },
      {
        key: "blackpink",
        label: "zap68BlackPink",
        image: keyboardZAP68BlackPink,
      },
      {
        key: "foggyBlack",
        label: "zap68FoggyBlack",
        image: keyboardZAP68FoggyBlack,
      },
    ],
    defaultColor: "black",
  },
  "X87 Neon": {
    deviceType: DeviceType.Keyboard,
    colors: [
      {
        key: "mistyBlue",
        label: "x87neonMistyBlue",
        image: keyboardX87NeonMistyBlue,
      },
    ],
    defaultColor: "mistyBlue",
  },

  // ==================== 耳机设备 ====================
  HG50: {
    deviceType: DeviceType.Earphone,
    colors: [
      {
        key: "white",
        label: "hg50White",
        image: earphoneHg50Default,
      },
    ],
    defaultColor: "white",
  },
  VX07: {
    deviceType: DeviceType.Earphone,
    colors: [
      {
        key: "blue",
        label: "vx07LuotianyiBlue",
        image: earphoneVx07LuotianyiBlue,
      },
    ],
    defaultColor: "blue",
  },
  /** Cmedia Xear：与 HG50 同构配色槽，VX01 / VX01S 独立 key，互不影响 */
  VX01: {
    deviceType: DeviceType.Earphone,
    colors: [
      {
        key: "black",
        label: "vx01Black",
        image: earphoneVx01Black,
      },
      {
        key: "white",
        label: "vx01White",
        image: earphoneVx01White,
      },
      {
        key: "berryred",
        label: "vx01BerryRed",
        image: earphoneVx01BerryRed,
      },
    ],
    defaultColor: "black",
  },
  VX01S: {
    deviceType: DeviceType.Earphone,
    colors: [
      {
        key: "black",
        label: "vx01sBlack",
        image: earphoneVx01sBlack,
      },
      {
        key: "whitePink",
        label: "vx01sWhitePink",
        image: earphoneVx01sWhitePink,
      },
      {
        key: "blackOrange",
        label: "vx01sBlackOrange",
        image: earphoneVx01sBlackOrange,
      },
    ],
    defaultColor: "black",
  },
  VX02: {
    deviceType: DeviceType.Earphone,
    colors: [
      {
        key: "blackRed",
        label: "vx02BlackRed",
        image: earphoneVx02BlackRed,
      },
      {
        key: "whiteBlue",
        label: "vx02WhiteBlue",
        image: earphoneVx02WhiteBlue,
      },
    ],
    defaultColor: "blackRed",
  },
  VX20: {
    deviceType: DeviceType.Earphone,
    colors: [
      {
        key: "blackRed",
        label: "vx20Default",
        image: earphoneVx20Default,
      },
      {
        key: "whitePink",
        label: "vx20Pink",
        image: earphoneVx20Pink,
      },
      {
        key: "whiteBlue",
        label: "vx20Blue",
        image: earphoneVx20Blue,
      },
    ],
    defaultColor: "blackRed",
  },
};

/**
 * 远程产品图配色（仅接口数据）。
 * 签名临近过期时仍返回已有 colors（stale-while-revalidate），由 ensureProductPic 刷新 URL；
 * 禁止回落 shared-assets。
 */
function resolveRemoteColors(
  resolvedDeviceId: string
): RemoteProductPicColor[] | null {
  const entry = findRemoteProductPicByModelKey(resolvedDeviceId);
  if (entry?.status === "ok" && entry.colors?.length) return entry.colors;

  // 兼容：后台按 :moudleId:N 分型号，C 端可能只缓存了裸型号（或相反）
  const normalized =
    typeof resolvedDeviceId === "string" ? resolvedDeviceId.trim() : "";
  const midIdx = normalized.indexOf(MOUDLE_ID_CONFIG_SEP);
  if (midIdx !== -1) {
    const baseEntry = findRemoteProductPicByModelKey(
      normalized.slice(0, midIdx)
    );
    if (baseEntry?.status === "ok" && baseEntry.colors?.length) {
      return baseEntry.colors;
    }
    return null;
  }
  if (normalized) {
    const hit = findRemoteProductPicByModelKeyPrefix(
      `${normalized}${MOUDLE_ID_CONFIG_SEP}`
    );
    if (hit?.length) return hit;
  }
  return null;
}

/** 本地 DEVICE_CONFIGS 仅保留键/标签；图片一律占位，绝不返回 /shared-assets 产品图 */
function localColorKeysAsPlaceholder(resolvedDeviceId: string): ColorOption[] {
  const config = registeredDevices[resolvedDeviceId];
  if (!config?.colors?.length) return [];
  return config.colors.map((c) => ({
    ...c,
    image: PRODUCT_PIC_PLACEHOLDER,
  }));
}

// 状态接口定义
interface ProductColorStore {
  // 存储每个设备的当前配色：deviceId -> colorKey
  deviceColors: Record<string, string>;

  canonId: (deviceId: string) => string;

  // 获取指定设备的当前配色
  getDeviceColor: (deviceId: string) => string;

  // 设置指定设备的配色
  setDeviceColor: (deviceId: string, colorKey: string) => void;

  // 获取指定设备配色的i18n键
  getDeviceColorLabel: (deviceId: string, colorKey?: string) => string;

  // 获取设备的配色选项列表
  getDeviceColorOptions: (deviceId: string) => ColorOption[];

  // 获取设备当前配色的图片 URL
  getDeviceImage: (deviceId: string, colorKey?: string) => string;

  colorLib: (deviceId: string) => Record<string, string>;

  // 注册新的设备配色配置
  registerDevice: (deviceId: string, config: DeviceColorConfig) => void;
}

// 存储已注册的设备配置
const registeredDevices: Record<string, DeviceColorConfig> = {
  ...DEVICE_CONFIGS,
};

/** 同显示名多物理设备并存（如 X98 8K + X98 1K）区分配色的分隔符 */
const PRODUCT_COLOR_INSTANCE_SEP = "@@";
/** DEVICE_CONFIGS 按 moudleId 分子配置的键后缀，如 `A8 WB Ultra:moudleId:19` */
const MOUDLE_ID_CONFIG_SEP = ":moudleId:";

/** 匠盟 module id；配置表字段 `moudleId` 与 SDK 字段 `mid` 为同一值 */
export function readMoudleId(source: unknown): number | undefined {
  if (source == null || typeof source !== "object") return undefined;
  const obj = source as { moudleId?: unknown; mid?: unknown };
  const raw = obj.moudleId ?? obj.mid;
  if (raw === undefined || raw === null || raw === "") return undefined;
  const n = Number(raw);
  return Number.isFinite(n) ? n : undefined;
}

function stripMoudleScopedConfigSuffix(configKey: string): string {
  const i = configKey.indexOf(MOUDLE_ID_CONFIG_SEP);
  return i === -1 ? configKey : configKey.slice(0, i);
}

function parseMoudleIdFromInstanceKey(deviceId: string): number | undefined {
  const midIdx = deviceId.indexOf(":mid:");
  if (midIdx === -1) return undefined;
  const n = Number(deviceId.slice(midIdx + 5).split(":")[0]);
  return Number.isFinite(n) ? n : undefined;
}

function readMoudleIdFromEquipmentData(
  vid?: number,
  pid?: number
): number | undefined {
  if (typeof window === "undefined") return undefined;
  try {
    const raw = localStorage.getItem("equipmentData");
    if (!raw) return undefined;
    const eq = JSON.parse(raw) as Record<string, unknown>;
    const moudleId = readMoudleId(eq) ?? readMoudleId(eq.deviceInfo);
    if (moudleId === undefined) return undefined;
    if (vid === undefined || (eq.vendorId === vid && eq.productId === pid)) {
      return moudleId;
    }
  } catch {
    /* ignore */
  }
  return undefined;
}

function resolveMoudleIdForConfig(deviceId: string): number | undefined {
  const fromKey = parseMoudleIdFromInstanceKey(deviceId);
  if (fromKey !== undefined) return fromKey;

  const sepIdx = deviceId.indexOf(PRODUCT_COLOR_INSTANCE_SEP);
  if (sepIdx !== -1) {
    const suffix = deviceId.slice(sepIdx + PRODUCT_COLOR_INSTANCE_SEP.length);
    const [vidStr, pidStr] = suffix.split(":");
    const vid = Number(vidStr);
    const pid = Number(pidStr);
    if (Number.isFinite(vid) && Number.isFinite(pid)) {
      const mouseList = SUPPORTED_DEVICES.mouse as Array<{
        vendorId?: number;
        productId?: number;
        moudleId?: number;
      }>;
      const match = mouseList.find(
        (d) => d.vendorId === vid && d.productId === pid
      );
      if (typeof match?.moudleId === "number") return match.moudleId;
      const fromEq = readMoudleIdFromEquipmentData(vid, pid);
      if (fromEq !== undefined) return fromEq;
    }
  }

  return readMoudleIdFromEquipmentData();
}

const canonIdInternal = (deviceId: string): string => {
  return typeof deviceId === "string" ? deviceId.trim() : "";
};

/** 解析为 DEVICE_CONFIGS 的 key，如 "EWEADN ES98" -> "ES98" */
const resolveDeviceConfigKey = (deviceId: string): string => {
  const trimmed = canonIdInternal(deviceId);
  if (!trimmed) return trimmed;

  const baseName = stripProductColorInstanceSuffix(trimmed);
  let baseKey = baseName;
  if (!registeredDevices[baseKey] && baseName.startsWith("EWEADN ")) {
    const without = baseName.slice(7).trim();
    if (registeredDevices[without]) baseKey = without;
  }

  const moudleId = resolveMoudleIdForConfig(deviceId);
  if (moudleId !== undefined) {
    const scopedKey = `${baseKey}${MOUDLE_ID_CONFIG_SEP}${moudleId}`;
    if (registeredDevices[scopedKey]) return scopedKey;
  }

  if (registeredDevices[trimmed]) return trimmed;
  if (registeredDevices[baseKey]) return baseKey;
  if (trimmed.startsWith("EWEADN ")) {
    const without = trimmed.slice(7).trim();
    if (registeredDevices[without]) return without;
  }
  return trimmed;
};

/**
 * 首页卡片配色存储键：同一 displayname 下区分实例。
 * - 优先 `VID:PID`：配置表里多条「显示名均为 X98」的 SKU 往往共用同一 uuid
 * - 在 VID+PID 已能区分的前提下再拼接 `:mid:`（moudleId）与 `:uuid:`
 */
export function productColorInstanceKey(
  eq:
    | {
        displayname?: unknown;
        vendorId?: unknown;
        productId?: unknown;
        uuid?: unknown;
        moudleId?: unknown;
      }
    | null
    | undefined
): string {
  const dnRaw = String(eq?.displayname ?? "").trim();
  const vidRaw = eq?.vendorId;
  const pidRaw = eq?.productId;
  const vid =
    vidRaw !== undefined && vidRaw !== null && vidRaw !== ""
      ? Number(vidRaw)
      : NaN;
  const pid =
    pidRaw !== undefined && pidRaw !== null && pidRaw !== ""
      ? Number(pidRaw)
      : NaN;
  const moudleId = readMoudleId(eq);
  const uuidArr = eq?.uuid as unknown[] | undefined;
  const u = Array.isArray(uuidArr) ? uuidArr[0] : eq?.uuid;
  const hasUuid = u !== undefined && u !== null && u !== "";

  if (Number.isFinite(vid) && Number.isFinite(pid)) {
    let key = `${dnRaw}${PRODUCT_COLOR_INSTANCE_SEP}${vid}:${pid}`;
    if (moudleId !== undefined) {
      key += `:mid:${moudleId}`;
    }
    if (hasUuid) {
      key += `:uuid:${String(u)}`;
    }
    return key;
  }
  if (hasUuid) {
    return `${dnRaw}${PRODUCT_COLOR_INSTANCE_SEP}uuid:${String(u)}`;
  }
  return dnRaw;
}

/** `X98@@14126:706` -> `X98`，用于解析 DEVICE_CONFIGS */
function stripProductColorInstanceSuffix(deviceId: string): string {
  if (typeof deviceId !== "string") return "";
  const i = deviceId.indexOf(PRODUCT_COLOR_INSTANCE_SEP);
  if (i === -1) return deviceId.trim();
  return deviceId.slice(0, i).trim();
}

/**
 * 仅用型号键（无 @@）或实例 VID/PID 与存储键不一致时：
 * 若 `deviceColors` 里恰好只有一条同型号 `型号@@…` 实例键，则使用该记录。
 * 多条实例键并存时不推断，避免多卡串色。
 */
function pickSingletonInstanceSavedColor(
  colors: Record<string, string>,
  resolvedDeviceId: string
): string | undefined {
  const targetBase = stripMoudleScopedConfigSuffix(
    stripProductColorInstanceSuffix(resolvedDeviceId)
  );
  const matchingKeys: string[] = [];
  for (const k of Object.keys(colors)) {
    if (!k.includes(PRODUCT_COLOR_INSTANCE_SEP)) continue;
    const stripped = stripProductColorInstanceSuffix(k);
    if (
      stripped === targetBase ||
      resolveDeviceConfigKey(k) === resolvedDeviceId
    ) {
      matchingKeys.push(k);
    }
  }
  if (matchingKeys.length === 1) {
    return colors[matchingKeys[0]];
  }
  return undefined;
}

/** 按设备展示名解析说明书链接（读取独立 JSON 配置） */
export interface InstructionLookupOptions {
  category?: "mouse" | "keyboard";
  provider?: string;
}

export function getProductInstructionUrl(
  deviceIdOrDisplayName: string,
  options?: InstructionLookupOptions
): string | undefined {
  const raw = canonIdInternal(deviceIdOrDisplayName);
  if (!raw) return undefined;
  const key = stripMoudleScopedConfigSuffix(
    resolveDeviceConfigKey(deviceIdOrDisplayName)
  );
  const cfg = instructionUrls as Record<string, unknown>;
  const category = options?.category;
  const provider = options?.provider;

  if (category && provider) {
    const scoped = (
      cfg?.[category] as Record<string, Record<string, string> | undefined>
    )?.[provider];
    const directUrl = scoped?.[key]?.trim();
    if (directUrl) return directUrl;
  }

  if (category) {
    const categoryNode = cfg?.[category] as Record<string, unknown> | undefined;
    if (categoryNode && typeof categoryNode === "object") {
      const categoryUrls: Record<string, string> = {};
      const appendCategoryUrls = (node: unknown) => {
        if (!node || typeof node !== "object") return;
        Object.entries(node as Record<string, unknown>).forEach(([k, v]) => {
          if (typeof v === "string") {
            categoryUrls[k] = v;
          } else {
            appendCategoryUrls(v);
          }
        });
      };
      appendCategoryUrls(categoryNode);
      const categoryUrl = categoryUrls[key]?.trim();
      if (categoryUrl) return categoryUrl;
    }
  }

  const allUrls: Record<string, string> = {};

  const appendUrls = (node: unknown) => {
    if (!node || typeof node !== "object") return;
    Object.entries(node as Record<string, unknown>).forEach(([k, v]) => {
      if (typeof v === "string") {
        allUrls[k] = v;
      } else {
        appendUrls(v);
      }
    });
  };

  appendUrls(cfg);

  const url = allUrls[key];
  const s = url?.trim();
  return s || undefined;
}

/** 按设备展示名解析 TFT屏幕宽高（读取对应型号 `DeviceColorConfig.screenWidth` 和 `DeviceColorConfig.screenHeight`） */
export function getProductScreenSize(deviceIdOrDisplayName: string): {
  screenWidth: number;
  screenHeight: number;
} {
  const raw = canonIdInternal(deviceIdOrDisplayName);
  if (!raw) return { screenWidth: 0, screenHeight: 0 };
  const key = stripMoudleScopedConfigSuffix(
    resolveDeviceConfigKey(deviceIdOrDisplayName)
  );
  const config = registeredDevices[key];
  const w = config?.screenWidth;
  const h = config?.screenHeight;
  if (w && h) {
    return { screenWidth: w, screenHeight: h };
  }
  return { screenWidth: 0, screenHeight: 0 };
}

// 从 localStorage 读取设备配色
const getInitialDeviceColors = (): Record<string, string> => {
  if (typeof window === "undefined") return {};

  const saved = localStorage.getItem("deviceColors");
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch {
      return {};
    }
  }

  return {};
};

// 保存设备配色到 localStorage
const saveDeviceColors = (deviceColors: Record<string, string>) => {
  if (typeof window !== "undefined") {
    localStorage.setItem("deviceColors", JSON.stringify(deviceColors));
  }
};

// 创建 zustand store
const store = create<ProductColorStore>((set, get) => ({
  deviceColors: getInitialDeviceColors(),

  canonId: (deviceId: string) => {
    return resolveDeviceConfigKey(deviceId);
  },

  getDeviceColor: (deviceId: string) => {
    const resolvedDeviceId = get().canonId(deviceId);
    const colors = get().deviceColors;
    const config = registeredDevices[resolvedDeviceId];

    let savedColor: string | undefined;
    if (Object.prototype.hasOwnProperty.call(colors, deviceId)) {
      savedColor = colors[deviceId];
    } else if (Object.prototype.hasOwnProperty.call(colors, resolvedDeviceId)) {
      savedColor = colors[resolvedDeviceId];
    }
    // 子应用/首页实例键不一致（如演示模式 session 与 local 的 VID/PID 分叉）时，单实例由此对齐。
    if (savedColor === undefined) {
      savedColor = pickSingletonInstanceSavedColor(colors, resolvedDeviceId);
    }

    // 检查保存的颜色是否在当前配置中存在
    if (savedColor && config) {
      let resolvedSaved = savedColor;
      if (resolvedDeviceId === "VX20") {
        const legacyVx20: Record<string, string> = {
          default: "blackRed",
          pink: "whitePink",
          blue: "whiteBlue",
        };
        resolvedSaved = legacyVx20[savedColor] ?? savedColor;
      }
      const colorExists = config.colors.some((c) => c.key === resolvedSaved);
      if (colorExists) {
        return resolvedSaved;
      }
    }

    // 如果保存的颜色不存在，使用默认颜色
    return config?.defaultColor || "black";
  },

  setDeviceColor: (deviceId: string, colorKey: string) => {
    const resolvedDeviceId = get().canonId(deviceId);
    const hasInstanceSep = deviceId.includes(PRODUCT_COLOR_INSTANCE_SEP);
    const storageKey = hasInstanceSep ? deviceId : resolvedDeviceId;

    const newColors = { ...get().deviceColors };

    if (!colorKey) {
      delete newColors[storageKey];
    } else {
      newColors[storageKey] = colorKey;
    }

    set({ deviceColors: newColors });

    // 持久化到 localStorage
    saveDeviceColors(newColors);

    // 触发自定义事件：detail.deviceId 必须为配色存储键（含 @@ 实例后缀），
    // 勿传折叠后的型号键；否则全局监听会写入 deviceColors["X98"]，多卡共用一条记录。
    if (typeof window !== "undefined") {
      const detail = {
        deviceId: storageKey,
        modelKey: resolvedDeviceId,
        colorKey,
      };
      const event = new CustomEvent("deviceColorChange", { detail });

      // 在当前 window 触发
      window.dispatchEvent(event);

      // BroadcastChannel：跨 qiankun 沙箱/iframe 边界的可靠同步通道
      try {
        const bc = new BroadcastChannel("eweadn:deviceColorChange");
        bc.postMessage(detail);
        bc.close();
      } catch {
        // BroadcastChannel 不可用时静默降级
      }

      // 在父 window 也触发（如果存在且不同），确保跨沙箱通信
      try {
        const rootWindow = window.parent || window.top || window;
        if (rootWindow && rootWindow !== window) {
          rootWindow.dispatchEvent(
            new CustomEvent("deviceColorChange", { detail })
          );
        }
      } catch (e) {
        // 跨域或权限问题，忽略
        console.debug("[useProductColor] 无法访问父窗口:", e);
      }

      console.log(`[useProductColor] 设置配色: ${storageKey} -> ${colorKey}`);
    }
  },

  getDeviceColorLabel: (deviceId: string, colorKey?: string) => {
    const resolvedDeviceId = get().canonId(deviceId);
    const config = registeredDevices[resolvedDeviceId];
    if (!config) return colorKey || "";

    const targetColor = colorKey || get().getDeviceColor(deviceId);
    const colorOption = config.colors.find((c) => c.key === targetColor);
    return colorOption?.label || targetColor;
  },

  getDeviceColorOptions: (deviceId: string) => {
    const resolvedDeviceId = get().canonId(deviceId);
    const remoteColors = resolveRemoteColors(resolvedDeviceId);
    if (remoteColors?.length) return remoteColors;
    return localColorKeysAsPlaceholder(resolvedDeviceId);
  },

  getDeviceImage: (deviceId: string, colorKey?: string) => {
    const resolvedDeviceId = get().canonId(deviceId);
    const targetColor = colorKey || get().getDeviceColor(deviceId);
    const remoteColors = resolveRemoteColors(resolvedDeviceId);
    if (remoteColors?.length) {
      const remoteHit =
        remoteColors.find((c) => c.key === targetColor) || remoteColors[0];
      return remoteHit?.image || PRODUCT_PIC_PLACEHOLDER;
    }
    // 接口未返回前 / 失败：占位图，禁止走 /shared-assets 产品外观图
    return PRODUCT_PIC_PLACEHOLDER;
  },

  colorLib: (deviceId: string) => {
    const resolvedDeviceId = get().canonId(deviceId);
    const remoteColors = resolveRemoteColors(resolvedDeviceId);
    if (remoteColors?.length) {
      return remoteColors.reduce<Record<string, string>>((acc, option) => {
        acc[option.key] = option.image || PRODUCT_PIC_PLACEHOLDER;
        return acc;
      }, {});
    }
    return localColorKeysAsPlaceholder(resolvedDeviceId).reduce<
      Record<string, string>
    >((acc, option) => {
      acc[option.key] = PRODUCT_PIC_PLACEHOLDER;
      return acc;
    }, {});
  },

  registerDevice: (deviceId: string, config: DeviceColorConfig) => {
    registeredDevices[deviceId] = config;
  },
}));

// 监听跨应用的配色变化
if (typeof window !== "undefined") {
  // 监听设备配色变化事件
  window.addEventListener("deviceColorChange", ((
    event: CustomEvent<{
      deviceId: string;
      colorKey: string;
      modelKey?: string;
    }>
  ) => {
    const { deviceId, colorKey } = event.detail || {};
    if (deviceId && colorKey) {
      const currentColors = store.getState().deviceColors;
      // 与 setDeviceColor 一致：按存储键合并，不得再 canon 成「X98」否则多卡串色
      store.setState({
        deviceColors: { ...currentColors, [deviceId]: colorKey },
      });
    }
  }) as EventListener);

  // 监听 storage 事件（用于跨标签页/窗口同步）
  window.addEventListener("storage", (event) => {
    if (event.key === "deviceColors" && event.newValue) {
      try {
        const newColors = JSON.parse(event.newValue);
        store.setState({ deviceColors: newColors });
      } catch {
        // 忽略解析错误
      }
    }
  });

  // BroadcastChannel 接收端：跨 qiankun 子应用/iframe 同步
  try {
    const bc = new BroadcastChannel("eweadn:deviceColorChange");
    bc.onmessage = (
      event: MessageEvent<{
        deviceId: string;
        colorKey: string;
        modelKey?: string;
      }>
    ) => {
      const { deviceId, colorKey } = event.data || {};
      if (deviceId && colorKey) {
        const currentColors = store.getState().deviceColors;
        store.setState({
          deviceColors: { ...currentColors, [deviceId]: colorKey },
        });
      }
    };
  } catch {
    // BroadcastChannel 不可用时静默降级
  }
}

/**
 * 产品配色 hook
 *
 * 自动同步跨应用的配色变化
 */
export const useProductColor = () => {
  const state = store();
  const { t } = useTranslation();
  const [, setRemoteVer] = useState(0);

  // 远程产品图缓存变更时触发重渲染（多页面共用同一份缓存）
  useEffect(
    () =>
      subscribeRemoteProductPics(() =>
        setRemoteVer(getRemoteProductPicVersion())
      ),
    []
  );

  // 组件挂载时检查 localStorage，确保与最新值同步
  useEffect(() => {
    const syncFromStorage = () => {
      const savedColors = localStorage.getItem("deviceColors");
      if (savedColors) {
        try {
          const colors = JSON.parse(savedColors);
          const currentColors = store.getState().deviceColors;
          if (JSON.stringify(colors) !== JSON.stringify(currentColors)) {
            store.setState({ deviceColors: colors });
          }
        } catch {
          // 忽略解析错误
        }
      }
    };

    syncFromStorage();

    // 页面从后台恢复时（从子应用切回）重新同步 localStorage
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        syncFromStorage();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // 窗口获得焦点时也同步一次（覆盖 qiankun 子应用切回场景）
    window.addEventListener("focus", syncFromStorage);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", syncFromStorage);
    };
  }, []);

  /**
   * 翻译颜色标签的辅助函数
   * @param key - 颜色的i18n键值（不带前缀，如 'z7Black', 'x87heBlackpink'）
   * @param deviceId - 设备ID，用于判断是键盘还是鼠标
   * @returns 翻译后的颜色名称
   */
  const translateColorLabel = (key: string, deviceId?: string): string => {
    // 如果已经包含完整前缀，直接翻译
    if (
      key.startsWith("keyboard.colors.") ||
      key.startsWith("mouse.colors.") ||
      key.startsWith("earphone.colors.")
    ) {
      return t(key);
    }

    // 根据设备类型自动添加前缀
    const resolvedDeviceId = deviceId ? state.canonId(deviceId) : null;
    const config = resolvedDeviceId
      ? registeredDevices[resolvedDeviceId]
      : null;
    const prefix =
      config?.deviceType === DeviceType.Mouse
        ? "mouse.colors"
        : config?.deviceType === DeviceType.Earphone
          ? "earphone.colors"
          : "keyboard.colors";

    return translatePrefixedColorKey(`${prefix}.${key}`, key, t);
  };

  return {
    ...state,
    translateColorLabel,
  };
};

/**
 * 注册设备配色配置
 * 用于动态添加新设备的配色方案
 */
export const registerDeviceConfig = (
  deviceId: string,
  config: DeviceColorConfig
) => {
  registeredDevices[deviceId] = config;
  store.getState().registerDevice(deviceId, config);
};
